<div class="layoutBlock">
    <div class="columnFull">
        <p-panel
            header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.a1bescheinigung' | hisUi}}"
            [toggleable]="false">

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.a1bescheinigung.socialSecurityNumber"
                    class="inputWidth100" [(ngModel)]="a1Bescheinigung.socialInsuranceNumber"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <p-autoComplete #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.a1bescheinigung.actualHealtInsurance"
                    styleClass="autocompleteWidth100" field="text" [(ngModel)]="a1Bescheinigung.healthInsuranceSelected"
                    hisEagerDataSource="api/v1/rm/erp/travelmanagement/values/erphealthinsurance"
                    [forceSelection]="true" (ngModelChange)="onModelChange($event)">
                </p-autoComplete>
            </his-plam>

            <h3>{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.a1bescheinigung.furtherDetails'
                | hisUi}}</h3>

            <his-plam>
                <textarea #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.a1bescheinigung.informationTravelDestination"
                    [(ngModel)]="a1Bescheinigung.destinationDetails" class="textareaWidth100" rows="3"
                    (ngModelChange)="onModelChange($event)"></textarea>
            </his-plam>

            <his-plam>
                <textarea #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.a1bescheinigung.lastTravelDestinations"
                    [(ngModel)]="a1Bescheinigung.destinationsOfTheLastYears" class="textareaWidth100" rows="5"
                    (ngModelChange)="onModelChange($event)"></textarea>
            </his-plam>

        </p-panel>

    </div>
</div>